app.controller("AreaPageController",
	["$scope", "$timeout", function($scope, $timeout) {

		$scope.isContactFormPresent = function() {
			if($('.b-developer-agencies').length > 0) {
				return true;
			}

			return false;
		};
	}]
);